<template>
  <div id="func-14">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <div
      v-if="detalhes"
      id="func-detalhes"
      class="func-detalhe"
    >
      <el-col
        :span="14"
        class="func-infos"
      >
        <h2 v-if="tituloDetalhe">{{ tituloDetalhe }}</h2>
        <div class="valor-content">
          <p
            class="valor"
            v-html="parseValor"
          ></p>
          <p class="situacao">Situação<br>
            <span :style="`color: ${detalhes.situacao.cor}`">{{ detalhes.situacao.descricao }}</span>
          </p>
        </div>
        <div class="info">
          <LabelDesc
            :descricao="vencimento"
            :negrito="true"
            label="Vencimento"
          />
          <LabelDesc
            v-if="exibirDataPagamento"
            :descricao="dataPagamento"
            :negrito="true"
            label="Pago em"
          />
          <LabelDesc
            :descricao="detalhes.cedenteNome"
            :label="'Cedente'"
          />
          <LabelDesc v-if="detalhes.atualizacaoValor"
            :descricao="parseValor"
            :label="'Valor atualizado'"
          />
          <LabelDesc
            :descricao="detalhes.tipoCobranca.descricao"
            :label="'Tipo'"
          />
          <LabelDesc
            :descricao="contrato.dadosTitular.nome"
            :label="'Titular'"
          />
          <LabelDesc
            :descricao="`${contrato.descricaoContrato} - ${contrato.numeroContrato}`"
            :label="textoVinculoContrato"
          />
        </div>
        <div class="dashed" v-if="detalhes.atualizacaoValor">
          <LabelDesc
            :descricao="formatData"
            :label="'Vencimento original'"
          />
          <LabelDesc
            :descricao="originalValue"
            :label="'Valor original'"
          />
        </div>
        <div class="dashed obs">
          <div class="obs-box">
          <p><span>Observações:</span><br>
            <span class="obs-text">{{ detalhes.observacao }}</span>
          </p>
          </div>
        </div>
      </el-col>
      <el-col
        id="func-actions"
        :span="10"
        class="func-actions"
      >
        <div
          v-if="!showButtonGerarCodigo"
          id="codigo-container"
          class="codigo-barras"
        >
          <p>Copie o código e use em seu app de pagamentos.</p>
<!--          <vue-barcode-->
<!--            :value="linhaDigitavel"-->
<!--          />-->
          <p class="codigo">{{ LinhaDigitavelFormatada }}</p>

          <el-button
            type="primary"
            :style="buttonStyle"
            @click="clipboardCopy"
          >
            Copiar Código
          </el-button>
<!--          <el-button-->
<!--            plain-->
<!--            :style="buttonStyleSecudary"-->
<!--            @click="toggleExpandir"-->
<!--          >-->
<!--            <span v-show="!expandir">Ampliar Código</span><span v-show="expandir">Reduzir Código</span></el-button>-->
        </div>

        <table
          v-if="detalhes.alerta && detalhes.alerta.mensagem"
          :style="styleAlerta"
          class="table-menu"
          style="margin-bottom: 15px;"
        >
          <tr>
            <td
              class="text-link"
              style="text-align: left; padding-right: 16px"
              width="20px"
            >
              <svg-icone
                :url="alertaIcone"
                cor="#FFFFFF"
              />
            </td>
            <td
              class="text-link"
              style="color: #FFFFFF;"
              width="*"
            >{{ detalhes.alerta.mensagem }}
            </td>
          </tr>
        </table>

        <table
          v-if="showButtonGerarCodigo"
          :style="style"
          class="table-menu"
          style="margin-bottom: 15px;"
          v-show="showOptionGerarCodigo && funcionalidade.parametros.solicitaGeracaoDeBoleto"
        >
          <tr
            @click="gerarCodigo"
          >
            <td
              class="text-link"
              style="text-align: left; padding-right: 16px"
              width="20px"
            >
              <svg-icone
                :url="barIcone"
                :cor="estilo.aplicacao.corPrimariaAplicacao"
                width="28"
                height="17"
              />
            </td>
            <td
              class="text-link"
              width="*"
            >
              Gerar código para boleto
            </td>
            <td
              class="text-link"
              style="text-align: right;"
              width="20px"
            ><i class="el-icon-arrow-right"/></td>
          </tr>
        </table>
        <MenuVertical
          v-if="visualizarResumoCobranca || visualizarBoletoPdf || visualizarComprovante"
          :columns="columns"
        />
      </el-col>
      <div class="clearfix"></div>
      <loading
        :loading="loading"
        :text="'Estamos gerando seu boleto.\nPor favor aguarde…'"
      />
    </div>
    <clipboard-alert v-if="showAlertClipboard" @hide="showAlertClipboard=!showAlertClipboard"/>
  </div>
</template>
<script>
import moment from 'moment'
// import VueBarcode from 'vue-barcode'
import MenuVertical from '@/components/MenuVertical/MenuVertical'
import LabelDesc from '@/components/common/LabelDesc.vue'
import Loading from '@/components/common/Loading.vue'
import { mapGetters, mapState } from 'vuex'
import { float2Money } from '@/utils/dinheiro'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { EnumSituacaoBoleto } from '@/views/14/Enums14'
import { urlIcons } from '@/utils/ImageBucket'
import {
  detalheBoleto,
  visualizarBoletoPdf,
  visualizarResumoCobranca,
  visualizarComprovante,
  exibirDataPagamento,
  comprovantePdf
} from '@/views/14/RegrasDeNegocio14'
import ClipboardAlert from '@/views/14/components/clipboard-alert'
export default {
  name: 'Func14Detalhe',
  components: {
    ClipboardAlert,
    FuncionalidadeHeader,
    LabelDesc,
    // VueBarcode,
    Loading,
    MenuVertical
  },
  data () {
    return {
      linkPDf: null,
      linkPDfBase: null,
      exibeCodigo: true,
      showOptionGerarCodigo: false,
      expandir: false,
      loading: false,
      detalhes: null,
      boleto: {},
      columns: [],
      showAlertClipboard: false
    }
  },
  computed: {
    ...mapGetters('Login', ['contratos']),
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'textoVinculoContrato']),
    style () {
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}14 !important`,
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao} !important`
      }
    },
    buttonStyle () {
      return {
        'background-color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    formatData () {
      const value = this.detalhes.atualizacaoValor.vencimentoOriginal
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    originalValue () {
      return float2Money(this.detalhes.atualizacaoValor.valorOriginal)
    },
    buttonStyleSecudary () {
      return {
        'border-color': this.estilo.aplicacao.corPrimariaAplicacao,
        'color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleAlerta () {
      return {
        'background': `${this.detalhes.alerta.cor} !important`,
        'color': `#FFFFFF !important`
      }
    },
    alertaIcone () {
      if (this.detalhes.alerta && this.detalhes.alerta.icone) {
        return urlIcons(this.detalhes.alerta.icone)
      }
      return ''
    },
    barIcone () {
      return urlIcons('Icon_barcode')
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    idTitulo () {
      return parseInt(this.$route.query.idTitulo)
    },
    codigoTitulo () {
      return this.$route.query.codigoTitulo
    },
    tituloDetalhe () {
      return this.detalhes.descricao
    },
    idRegistro () {
      return this.$route.query.idRegistro
    },
    parseValor () {
      const v = this.detalhes.valor || 0
      return float2Money(v)
    },
    vencimento () {
      const value = this.detalhes.dataVencimento
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    dataPagamento () {
      const value = this.detalhes.dataPagamento
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    contrato () {
      return this.contratos.find((contrato) => contrato.numeroContrato === this.detalhes.numeroContrato)
    },
    visualizarComprovante () {
      return visualizarComprovante(this.detalhes)
    },
    visualizarBoletoPdf () {
      return visualizarBoletoPdf(this.detalhes)
    },
    visualizarResumoCobranca () {
      return visualizarResumoCobranca(this.detalhes)
    },
    exibirDataPagamento () {
      return exibirDataPagamento(this.detalhes)
    },
    linhaDigitavel () {
      if (this.detalhes.boleto) {
        return this.detalhes.boleto.linhaDigitavel || ''
      }
      return ''
    },
    LinhaDigitavelFormatada () {
      if (this.linhaDigitavel) {
        return this.linhaDigitavel.replace(
          /^(\d{5})(\d{5})(\d{5})(\d{6})(\d{5})(\d{6})(\d{1})(\d{14})$/,
          '$1.$2 $3.$4 $5.$6 $7 $8'
        )
      }
      return this.linhaDigitavel
    },
    showButtonGerarCodigo () {
      return (this.linhaDigitavel === '')
    },
    solicitaConfirmacao () {
      if (this.detalhes.boleto) {
        return this.detalhes.boleto.solicitaConfirmacao || false
      }
      return false
    }
  },
  methods: {
    async init () {
      await this.getDetalhe()
      await this.showBarCode()
      this.fillColumns()
    },
    async loadBoleto () {
      const response = await this.apiFuncionalidade.boletoPdf({
        payload: {
          idTitulo: this.$route.query.idTitulo,
          codigoTitulo: this.codigoTitulo
        },
        loading: true,
        handlerErrorIgnore: [404]
      })
      if (response.data.url) {
        this.linkPDf = response.data.url
      }
      if (response.data.base64) {
        this.linkPDfBase = response.data.base64
      }
    },
    async showBarCode () {
      const situacao = this.detalhes.situacao.id
      if (
        situacao === EnumSituacaoBoleto.aberto ||
        situacao === EnumSituacaoBoleto.vencido
      ) {
        setTimeout(() => {
          this.showOptionGerarCodigo = true
          this.loading = false
        }, 500)
      }
    },
    async getDetalhe () {
      this.detalhes = await detalheBoleto(this.idTitulo, this.codigoTitulo, this.idRegistro)
    },
    async confirmaGerarBoleto () {
      return this.$confirm(this.detalhes.boleto.textoConfirmacao, 'Confirmação', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },
    async gerarCodigo () {
      this.loading = true
      if (this.solicitaConfirmacao) {
        const confirma = await this.confirmaGerarBoleto()
        if (!confirma) {
          this.loading = false
          return
        }
      }
      const response = await this.apiFuncionalidade.gerarBoleto({
        payload: {
          idTitulo: this.idTitulo,
          codigoTitulo: this.codigoTitulo
        },
        handlerErrorIgnore: true
      })
      this.boleto = response.data
      this.detalhes.boleto.linhaDigitavel = this.boleto.linhaDigitavel
      setTimeout(() => {
        this.exibeCodigo = true
        this.loading = false
      }, 500)
    },
    fillColumns () {
      this.columns = [
        {
          title: this.funcionalidade.parametros.labelDoBotaoResumoCobranca,
          action: this.verResumo,
          show: this.visualizarResumoCobranca
        },
        {
          title: this.funcionalidade.parametros.labelDoBotaoBoletoEmPdf,
          action: this.verBoleto,
          show: this.visualizarBoletoPdf
        },
        {
          title: this.funcionalidade.parametros.labelDoBotaoComprovantePagamento,
          action: this.verComprovante,
          show: this.visualizarComprovante
        }
      ]
    },
    verResumo () {
      this.$router.push({ path: '/14/resumoCobranca',
        query: {
          idTitulo: this.idTitulo,
          tituloDetalhe: this.tituloDetalhe,
          vencimento: this.detalhes.dataVencimento,
          valor: this.parseValor,
          codigoTitulo: this.codigoTitulo
        }
      })
    },
    async verComprovante () {
      const comprovante = await comprovantePdf(this.idTitulo, this.codigoTitulo)
      if (comprovante.url) {
        window.open(comprovante.url, '_blank')
      }
      if (comprovante.base64) {
        window.open(this.baseToUrl(comprovante.base64), '_blank')
      }
    },
    async verBoleto () {
      await this.loadBoleto()
      if (this.linkPDf) {
        window.open(this.linkPDf, '_blank')
      }
      if (this.linkPDfBase) {
        window.open(this.baseToUrl(this.linkPDfBase), '_blank')
      }
    },
    baseToUrl (base) {
      const binaryPDF = window.atob(base)
      const byteArray = new Uint8Array(binaryPDF.length)
      for (let i = 0; i < binaryPDF.length; i++) {
        byteArray[i] = binaryPDF.charCodeAt(i)
      }
      const blob = new Blob([byteArray], { type: 'application/pdf' })

      return URL.createObjectURL(blob)
    },
    clipboardCopy () {
      if (this.$clipboard(this.linhaDigitavel)) {
        this.showAlertClipboard = true
      }
    },
    toggleExpandir () {
      const element = document.getElementById('codigo-container')
      element.parentNode.removeChild(element)

      if (this.expandir) {
        this.expandir = false
        document.getElementById('func-actions').prepend(element)
      } else {
        this.expandir = true
        document.getElementById('func-detalhes').prepend(element)
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped lang="less">

p.codigo {
  word-wrap: break-word;
}
</style>
